import produce from "immer";
import { LoadState } from "../../../constants/enums";
import {
  IGLFiscalYearCloseState,
  initialGLFiscalYearCloseState,
} from "./GLFiscalYearClose.types";
import { GLFiscalYearCloseActions } from ".";
import {
  CLEAR_GL_FISCAL_YEAR_CLOSE_STATE,
  FETCH_GL_FISCAL_YEAR_CLOSE_LIST_FAILED,
  FETCH_GL_FISCAL_YEAR_CLOSE_LIST_PROGRESS,
  FETCH_GL_FISCAL_YEAR_CLOSE_LIST_SUCCESS,
} from "./GLFiscalYearCloseActions";

export const glFiscalYearCloseReducer = (
  state: IGLFiscalYearCloseState = initialGLFiscalYearCloseState,
  action: GLFiscalYearCloseActions
) => {
  switch (action.type) {
    case FETCH_GL_FISCAL_YEAR_CLOSE_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.list = [];
        draftState.totalRecords = 0;
        draftState.loading = LoadState.InProgress;
        draftState.error = null;
      });
      return newState;
    }

    case FETCH_GL_FISCAL_YEAR_CLOSE_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = data;
        draftState.totalRecords = totalRecords;
        draftState.error = null;
      });
      return newState;
    }

    case FETCH_GL_FISCAL_YEAR_CLOSE_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.list = [];
        draftState.totalRecords = 0;
        draftState.loading = LoadState.Failed;
      });
      return newState;
    }

    case CLEAR_GL_FISCAL_YEAR_CLOSE_STATE: {
      return initialGLFiscalYearCloseState;
    }

    default:
      return state;
  }
};
